import profile from "./assets/profile.jpg";

export const personalData = {
  name: "Abuzar Yaseen",
  // designation: ["Frontend Developer"],
  designation: "Frontend Engineer",
  github: "https://github.com/AbuzarYaseen",
  linkedIn: "https://www.linkedin.com/in/abuzar-yaseen/",
  facebook: "https://www.facebook.com/abuzar.yaseen.3",
  instagram: "https://www.instagram.com/abuzaryaseen88/",
  skills: [
    "HTML",
    "CSS",
    "Javascript",
    "ReactJs",
    "NextJs",
    "GROQ",
    "Sanity",
    "Tailwind css",
    "Git",
    "GSAP Animations",
    "Bootstrap",
    "Material UI",
    "Ant Design",
    "shadcn/ui",
    "TypeScript",
    "Redux Toolkit",
    "Redux",
    "REST API",
    "Firebase",
    "Netlify",
    "Vercel",
    "Chakra UI",
    "Styled Components",
    "SASS",
  ],
  email: "abuzaryaseen88@gmail.com",
  phone: "+923054664830",
  address: "Lahore, Pakistan",
};

export const AboutData = {
  name: "Abuzar Yaseen",
  description: [
    "I’m a Frontend Engineer with 2 years of experience building fast, scalable, and user-focused web applications using React.js and Next.js. I specialize in creating clean, responsive interfaces with a strong focus on performance and usability.",

    "I developed Cyber Evangelists and contributed to platforms like Attack Insights, 6sides.org, and pinizo.com.",

    "I’m passionate about writing maintainable code, optimizing performance, and continuously improving my skills to build high-quality web experiences.",
  ],
  profile: profile,
};

export const experiences = [
  {
    id: 1,
    title: "Software Engineer",
    company: "Sync Scrum",
    duration: "(Aug 2025 - Present)",
    location: "Lahore, Pakistan",
    responsibilities: [
      "Frontend development with ReactJs, NextJs Framework, Tailwind, and AntD",
      "Performance and optimization of live products",
      "Provide optimal solutions",
    ],
  },
  {
    id: 2,
    title: "Frontend Software Engineer",
    company: "Cyber Evangelists",
    duration: "(Sep 2024 - Aug 2025)",
    location: "Lahore, Pakistan",
    responsibilities: [
      "Frontend development with ReactJs, NextJs Framework, Tailwind, and AntD",
      "Performance and optimization of live products",
      "Provide optimal solutions",
    ],
  },
  {
    id: 3,
    title: "React Developer",
    company: "Codistal",
    duration: "(Feb 2024 - Jul 2024)",
    location: "Lahore, Pakistan",
    responsibilities: [
      "Frontend development with ReactJs, and Tailwind",
      "Performance and optimization of live products",
      "Provide optimal solutions",
    ],
  },
  {
    id: 4,
    title: "React Developer Intern",
    company: "Zeikh Technologies",
    duration: "(Nov 2023 - Jan 2024)",
    location: "Lahore, Pakistan",
    responsibilities: [
      "Backend development with SFRA architecture",
      "Provide optimal solutions",
      "Performance and optimization of live products",
    ],
  },
];

export const skillsData = [
  // "Photoshop",
  // "Angular",
  // "Nuxt Js",
  // "Vue",
  // "Postgresql",
  // "Vuetifyjs",
  // "C",
  // "Flutter",
  // "Flask",
  // "Docker",
  // "NodeJs",
  // "MongoDB",
  // "GCP",
  // "Dart",
  "Next Js",
  "Typescript",
  "Tailwind",
  "ViteJs",
  "C++",
  "Sanity",
  "Groq",
  "Firebase",
  "MaterialUI",
  "Figma",
  "MySQL",
  "ReactJs",
  "Bootstrap",
  "SAAS",
  "HTML",
  "CSS",
  "Javascript",
  "Git",
  "office",
  // "c#",
  // "illustrator",
  // "ionic",
  // "Python",
  // "Django",
  // "Django Rest Framework",
  // "RestAPI",
  // "Elixir",
  // "Phoenix",
  // "PostgreSQL",
  // "AWS",
  // "React Native",
  // "PHP",
  // "Laravel",
  // "DataScience",
  // "FastAPI",
  // "redis",
  // "graphql",
  // "microservices",
  // "jenkins",
  // "ionic",
];

export const educations = [
  {
    id: 1,
    title: "Bachelors in Computer Science",
    duration: "2019 - 2023",
    institution: "University of Engineering and Technology, Lahore",
  },
];

export const ContactMe = {
  description:
    "If you have any questions or concerns, please don't hesitate to contact me. I am open to any work opportunities that align with my skills and interests.",
};

export const projectsData = [
  {
    id: 1,
    name: "Firebase Auth System",
    description:
      "Secure user authentication application developed with Next.js and Firebase. Implements multi-provider sign-in, account verification, password reset, and cloud-based user data storage to deliver a smooth and scalable onboarding flow.",
    liveUrl: "",
    role: "Frontend Developer",
    stack: "Next.js, React, Firebase Authentication, Firestore, Tailwind CSS",
  },
  {
    id: 2,
    name: "Blogs Application",
    description:
      "A blogging platform built with Next.js, MongoDB, and Tailwind CSS. It allows users to create, edit, and delete blog posts, as well as view and comment on posts created by other users.",
    liveUrl: "",
    role: "Full Stack Developer",
    stack: "Next.js, MongoDB, Tailwind CSS",
  },
  {
    id: 2,
    name: "PlayNova",
    description:
      "Modern streaming discovery platform for movies and TV shows. Features trending content, advanced filtering, provider-based browsing, search, season navigation, and embedded playback powered by TMDB data through a secure proxy API.",
    liveUrl: "https://playnova-five.vercel.app/",
    role: "Frontend Developer",
    stack: "Next.js, React, TypeScript, Tailwind CSS, TMDB API, Shadcn/ui",
  },
];
